import type { WithdrawnAwardLettersRoundDto } from "../../../autogen/bff-api";

const SAME_REVOCATION_MS = 60_000;

export const withdrawnRoundFor = (
  revokedAt: string,
  rounds: readonly WithdrawnAwardLettersRoundDto[],
): WithdrawnAwardLettersRoundDto | undefined => {
  const revoked = Date.parse(revokedAt);
  return rounds
    .map((round) => ({ round, gap: Math.abs(Date.parse(round.withdrawnAt) - revoked) }))
    .filter(({ gap }) => gap <= SAME_REVOCATION_MS)
    .sort((a, b) => a.gap - b.gap)[0]?.round;
};
